import React from 'react';
import { Link } from 'react-router-dom';
import img1 from "../../../assets/images/home_page_4/product/01.png";
import img2 from "../../../assets/images/home_page_4/product/02.png";
import img3 from "../../../assets/images/home_page_4/product/03.png";

const products = [
    {
        id: 1,
        img: img1,
        title: "Sony A7 III Mirrorless Camera with 4K Video",
        price: "$159.77",
        available: 79,
        sold: 18,
    },
    {
        id: 2,
        img: img2,
        title: "Sony A7 III Mirrorless Camera with 4K Video",
        price: "$159.77",
        available: 79,
        sold: 18,
    },
    {
        id: 3,
        img: img3,
        title: "Sony A7 III Mirrorless Camera with 4K Video",
        price: "$159.77",
        available: 79,
        sold: 18,
    },
];

const HomeProduct = () => {
    return (
        <div>
            <section id="home-product" className="home-product-main-block">
                <div className="container">
                    <div className="row">
                        {products.map(product => (
                            <div key={product.id} className="col-lg-4 col-md-4">
                                <div className="home-product-block text-center">
                                    <div className="home-product-img">
                                        <Link to="/ShopDetails" title="">
                                            <img src={product.img} className="img-fluid" alt={product.title} />
                                        </Link>
                                    </div>
                                    <div className="home-product-dtls text-start">
                                        <ul>
                                            <li className="icons"><i className="flaticon-star"></i></li>
                                            <li className="icons"><i className="flaticon-star"></i></li>
                                            <li className="icons"><i className="flaticon-star"></i></li>
                                            <li className="icons"><i className="flaticon-star"></i></li>
                                            <li className="icons"><i className="flaticon-star"></i></li>
                                            <li className="total-rating">(3)</li>
                                        </ul>
                                        <h4 className="home-product-heading">
                                            <Link to="/ShopDetails" title="">{product.title}</Link>
                                        </h4>
                                        <div className="product-price-cart-block">
                                            <div className="row">
                                                <div className="col-lg-6 col-6">
                                                    <div className="home-product-price">
                                                        {product.price}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-6">
                                                    <div className="home-product-cart">
                                                        <Link to="/ShopDetails" title="">
                                                            <i className="flaticon-shopping-cart"></i>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="progress-block">
                                            <progress className="progress-bar" value="60" max="100"></progress>
                                            <div className="row">
                                                <div className="col-lg-6 col-6">
                                                    <div className="product-avail">Available: <b>{product.available}</b></div>
                                                </div>
                                                <div className="col-lg-6 col-6">
                                                    <div className="product-sold">Sold: <b>{product.sold}</b></div>
                                                </div>
                                            </div>
                                        </div>
                                        <p>Time remaining until the end of the offer.</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}

export default HomeProduct;